module.exports = __webpack_public_path__ + "media/images/photos/red-d8ad23d8417370f167a9ddb8f5a64d54.jpg";